import { useToast } from "@wayflyer/flyui";
import { useEffect } from "react";
import type { BankConnectCountryConfig } from "shared-ui";
import { useErrorModal } from "shared-ui";

import type { TruelayerBankConnectSchema } from "../../api-types/bankconnect_schemas";

export function useBankConnectWithTruelayer({ authStartUrl }: TruelayerBankConnectSchema) {
  const toaster = useToast();
  const { openErrorModal } = useErrorModal();

  const urlParams = new URLSearchParams(window.location.search);
  const isTruelayerCallback = urlParams.get("complete-connection") === "truelayer";
  const oAuthError = urlParams.has("oauth-error");

  useEffect(() => {
    if (isTruelayerCallback) {
      if (!oAuthError) {
        toaster.positive("Successfully connected");
      } else {
        openErrorModal({
          variant: "unknown",
          error: new Error(urlParams.get("oauth-error") || "Truelayer connection failed"),
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function startConnect(countrySelection?: BankConnectCountryConfig) {
    const authUrl = new URL(`${window.location.origin}${authStartUrl}`);
    if (countrySelection) {
      authUrl.searchParams.append("country_code", countrySelection.code);
    }
    window.location.href = authUrl.href;
  }

  return {
    startConnect,
  };
}
